import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./shared";

export const ProofBar = () => (
  <section
    className="relative pt-16 pb-16 sm:pt-24 sm:pb-20 border-b border-[#F2F0EB]/5"
    data-testid="proof-bar-section"
  >
    <Reveal className="mx-auto max-w-4xl px-5 sm:px-8 text-center">
      <p className="eyebrow mb-6 sm:mb-8" data-testid="proof-bar-label">
        Provenance
      </p>
      <h2
        className="h-heavy text-3xl sm:text-4xl lg:text-5xl leading-[1] text-[#F2F0EB] mb-6"
        data-testid="proof-bar-headline"
      >
        Built on the clock
        <br />
        <span className="text-[#6E7178]">in&nbsp;every&nbsp;one&nbsp;of&nbsp;your&nbsp;cells.</span>
      </h2>
      <p
        className="text-[#9DA1A8] leading-relaxed max-w-2xl mx-auto text-sm sm:text-base mb-5"
        data-testid="proof-bar-body"
      >
        Your body keeps 24 hour time. Cortisol, melatonin, temperature and
        attention all run on it, which is why 9am you and 4pm you are not the
        same person. We turn that clock into timing you can actually use.
      </p>
      <p
        className="mt-6 sm:mt-8 font-mono-brand text-[10px] sm:text-[11px] tracking-[0.14em] uppercase text-[#6E7178]"
        data-testid="proof-bar-horizons-credit"
      >
        *Circadian biology, peer reviewed &middot; 2017 Nobel Prize in Physiology or Medicine
      </p>
      <div className="mt-5 sm:mt-6">
        <Link
          to="/science"
          className="group inline-flex items-center gap-2 text-[#FF4D0A] hover:opacity-80 transition-opacity"
          data-testid="proof-bar-science-link"
        >
          <span className="font-mono-brand text-xs tracking-[0.18em] uppercase">Read the science</span>
          <ArrowUpRight size={13} className="transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </Reveal>
  </section>
);
